import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const BusinessDetailsPageActionButtons = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { businessProfiles } = useTranslatedMessages();
  const actions = businessProfiles?.actions ?? {};

  const onClickingBackButton = () => {
    return navigate('/business-profiles');
  };

  return (
    <>
      <Button
        id="business-profile-back"
        key="back"
        variant="contained"
        color="primary"
        onClick={onClickingBackButton}
        className="action-button"
        sx={{ marginLeft: theme.spacing(1) }}
      >
        {actions.back ?? 'Back'}
      </Button>
    </>
  );
};

export default BusinessDetailsPageActionButtons;
